import { render, staticRenderFns } from "./CurrentAddress.vue?vue&type=template&id=709e7807&scoped=true"
import script from "./CurrentAddress.vue?vue&type=script&lang=js"
export * from "./CurrentAddress.vue?vue&type=script&lang=js"
import style0 from "./CurrentAddress.vue?vue&type=style&index=0&id=709e7807&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709e7807",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('709e7807')) {
      api.createRecord('709e7807', component.options)
    } else {
      api.reload('709e7807', component.options)
    }
    module.hot.accept("./CurrentAddress.vue?vue&type=template&id=709e7807&scoped=true", function () {
      api.rerender('709e7807', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/logisticsOrders/components/CurrentAddress.vue"
export default component.exports